import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpBackend } from '@angular/common/http';
import { TranslationService } from '../base/translation.service';

@Injectable({
  providedIn: 'root',
})
export class GeocodingService {
  private readonly http = inject(HttpClient);
  private readonly httpNoInterceptors = inject(HttpBackend);
  private readonly translationService = inject(TranslationService);

  async getAddressFromCoordinates(lat: string, lng: string): Promise<string | undefined> {
    const lang = this.translationService.getCurrentLanguage();
    const url = `https://nominatim.openstreetmap.org/reverse?format=json&lat=${lat}&lon=${lng}&accept-language=${lang}`;
    const response = await this.http.get<{ display_name?: string }>(url).toPromise();
    return response?.display_name;
  }

  async getAddressFromCoordinatesGoogle(lat: string, lng: string): Promise<string | undefined> {
    try {

      const lang = this.translationService.getCurrentLanguage();
      const apiKey = ''; //environment.geocodingApiKey;
      const url = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=${apiKey}&language=${lang}`;
      const httpClientNoInterceptors = new HttpClient(this.httpNoInterceptors);
      const response = await httpClientNoInterceptors.get<{ results?: { formatted_address?: string }[]; status?: string }>(url).toPromise();
      if (response?.status === 'OK' && response?.results?.[0]?.formatted_address) {
        return response.results[0].formatted_address;
      }
      return undefined;
    } catch (error) {
      console.error('Error fetching address from Google Geocoding API:', error);
      return undefined;
    }
  }
}
